<div class="d-flex account-on-hold-simple text-left p-3">
    Account on credit hold. Contact
    <a [href]="'mailto:support@cargosprint.com' | sanitize: 'url'"> support&#64;cargosprint.com </a>
</div>
